// Runtime config. Vite inlines import.meta.env.VITE_* at build time;
// for production we point at solix.ibex.now:21443 (POC) or
// lifestyle.ibex.now (long-term).
//
// In dev the defaults below talk to a local lifestyle-aide on
// 127.0.0.1:21115 — match the LIFESTYLE_AIDE_PORT in aide_main.py.

const isBrowser = typeof window !== "undefined";

function inferDefaultAideBase(): { http: string; ws: string } {
  if (!isBrowser) {
    return {
      http: "http://127.0.0.1:21115",
      ws: "ws://127.0.0.1:21115",
    };
  }
  // When the surface is served behind lifestyle-edge under /app/lifestyle/,
  // we should hit /v1/aide and /ws/v1/aide on the SAME origin (the edge
  // proxies both to lifestyle-aide). That keeps cookies + TLS simple.
  const { protocol, host } = window.location;
  const wsProto = protocol === "https:" ? "wss:" : "ws:";
  return {
    http: `${protocol}//${host}`,
    ws: `${wsProto}//${host}`,
  };
}

const defaults = inferDefaultAideBase();

export const AIDE_HTTP_BASE: string =
  (import.meta.env.VITE_AIDE_HTTP_BASE as string | undefined) ?? defaults.http;

export const AIDE_WS_BASE: string =
  (import.meta.env.VITE_AIDE_WS_BASE as string | undefined) ?? defaults.ws;

// When served behind CloudFront under cdn.solix.ibex.now/app/lifestyle/,
// every API + WS call is prefixed with /app/lifestyle so the CDN can
// route to the lifestyle-edge origin. CloudFront strips the prefix
// before the request hits the backend, so the edge keeps serving its
// native /v1/aide, /ws/v1/aide, /api/v1/... paths.
const _PREFIX =
  isBrowser && /^\/app\/lifestyle(\/|$)/.test(window.location.pathname)
    ? "/app/lifestyle"
    : "";

export const AIDE_WS_PATH = `${_PREFIX}/ws/v1/aide`;
export const AIDE_HTTP_PATH = `${_PREFIX}/v1/aide`;

// UC-11 unified stream — agent-graph + PACT events for the
// AgentGraphPanel render surface.
export const UNIFIED_STREAM_PATH =
  `${_PREFIX}/api/v1/lifestyle/triton/unified_stream`;
